import React, { useState, useEffect, useCallback, useContext } from "react";
import { EmployeeNavbar } from "../reusedcomponent/navbar";
import { AuthContext } from "../../../../Context/AuthContext";
import ViewDetailModal from "../modals/view_details";
import { ApiService } from "../../../../services/ApiService";
import { useAlert } from "react-alert";
import { ConfirmTemplate } from "../../../../components/confirm";
import { Link } from "react-router-dom";
import { constant } from "../../../../Constants/constant";
import useModal from "../../../../utils/useModal";
import Modal from "react-modal";
import { employeeMngtThunk } from "../../../../store/actions/employeemanagement/employee.thunk";
import { useDispatch, useSelector } from "react-redux";

const customStyles = {
  content: {
    top: "40%",
    left: "50%",
    right: "50%",
    bottom: "auto",
    marginRight: "-60%",
    transform: "translate(-50%, -50%)",
    overflow: "scroll",
    width: "1000px",
    height: "100vh",

    // border: "2px solid green",
  },
};

Modal.setAppElement("#root");

export const Id_Card = () => {
  const alert = useAlert();
  const [modalopen, Setmodalopen] = useState(false);
  const { user } = useContext(AuthContext);
  const [employee, setEmployee] = useState();
  // const { modalIsOpen, openModal, closeModal } = useModal();
  const { employees } = useSelector((state) => state.employeeMngt);
  const dispatch = useDispatch();

  const [modalIsOpen, setIsOpen] = useState(false);

  // const openModal = () => {
  //   setIsOpen(true);
  // };

  const closeModal = () => {
    setIsOpen(false);
  };

  const deActivate = (slug) => {
    const request = async () => {
      const user_id = {
        slug: slug,
      };
      const res = await ApiService.post("deactivate-user", user_id);
      if (res.data.type === false) {
        alert.error(res.data.msg);
      } else if (res.data.type === true) {
        alert.success(res.data.msg);
        getEmployeesDetails();
      }
    };
    ConfirmTemplate(
      {
        title: "Deactivate User",
        message: "Are You Sure You Want To Deactivate This User",
      },
      request
    );
  };

  const getEmployeesDetails = useCallback(async () => {
    await dispatch(employeeMngtThunk.getEmployeesDetails());
  }, [dispatch]);

  useEffect(() => {
    getEmployeesDetails();
  }, []);

  return (
    <React.Fragment>
      <EmployeeNavbar />

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="view user datails modal"
      >
        <ViewDetailModal closeModal={closeModal} user={employee} />
      </Modal>

      <div className="row container">
        {employees.map((employee, i) => (
          <div className="col-md-3" key={i}>
            <div class="text-center card-box-four id-card-generate">
              <div class="mt-3">
                <img
                  src="/img/Needle_logo.png"
                  width="150px"
                  alt="needlelogo"
                  height="50px"
                />
              </div>
              <div class="clearfix"></div>
              <div class="member-card">
                <div class="thumb-xl member-thumb m-b-10 mx-auto mt-3 top-image-cover">
                  <img
                    src={`${constant.ImgURL}/uploads/${employee.profile_picture}`}
                    className="img-thumbnail"
                    alt="profile"
                  />
                </div>

                <div class="shadow divider"> </div>

                <div class="card-main-content mt-1">
                  <center>
                    {" "}
                    <div class="button-image-cover"></div>{" "}
                  </center>

                  <h4 class="font-20 text-white">{employee.first_name} </h4>
                  <h4> {employee.last_name} </h4>
                  <hr className="bg-danger" />
                  <p class="text-white">{employee.roles.name}</p>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/container/dashboard/employeemanagement/employees/id_card.js